var React = require('react');

function LinkSvg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.0598 10.9395C15.3098 13.1895 15.3098 16.8295 13.0598 19.0695C10.8098 21.3095 7.16985 21.3195 4.92985 19.0695C2.68985 16.8195 2.67985 13.1795 4.92985 10.9395","stroke":"#EEEEEE","strokeOpacity":"0.85","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10.5909 13.4109C8.25094 11.0709 8.25094 7.27086 10.5909 4.92086C12.9309 2.57086 16.7309 2.58086 19.0809 4.92086C21.4309 7.26086 21.4209 11.0609 19.0809 13.4109","stroke":"#EEEEEE","strokeOpacity":"0.85","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

LinkSvg.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LinkSvg;

LinkSvg.default = LinkSvg;
